/*
  PDP landing helpers — loaded by the "Page styles" section on landing product
  templates (e.g. product.advanced-skin-coat).

  1. Links to #pdp-buy scroll to the purchase options.
  2. Links to #product-facts — and the "View full product facts" button when
     its link is left empty — open the gallery image whose alt text mentions
     "supplement" or "facts" and scroll the gallery into view.
*/
(function () {
  'use strict';

  function scrollToEl(el) {
    if (!el) return false;
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    return true;
  }

  function findFactsThumb() {
    var thumbs = document.querySelectorAll('[data-slideshow-thumbnail]');
    for (var i = 0; i < thumbs.length; i++) {
      var label = (thumbs[i].getAttribute('aria-label') || '').toLowerCase();
      if (label.indexOf('facts') !== -1 || label.indexOf('supplement') !== -1) {
        return thumbs[i];
      }
    }
    return null;
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest(
      'a[href="#pdp-buy"], a[href="#product-facts"], [id$="__pdp_inside_more"] a.standard__cta[href="#"]'
    );
    if (!link) return;

    if (link.getAttribute('href') !== '#pdp-buy') {
      var thumb = findFactsThumb();
      if (thumb) thumb.click();
      if (scrollToEl(document.querySelector('[data-product-slideshow]'))) {
        event.preventDefault();
      }
      return;
    }

    var target =
      document.getElementById('pdp-buy') ||
      document.querySelector('[data-subscription-selectors]') ||
      document.querySelector('.product__block__buttons');
    if (scrollToEl(target)) {
      event.preventDefault();
    }
  });

  /*
    3. Start on "Subscribe & Save", as in the mockup.
       Switched on by data-preselect-subscription="true" in the "Page styles"
       section; set it to "false" to start on one-time purchase instead.
       Leaves the choice alone when the URL already picks a plan or the
       shopper has already picked one. Sets the same state the theme sets
       when a shopper clicks the option, so the cart gets the selling plan
       and the theme shows the subscription price once it loads.
  */
  function preselectSubscription() {
    var options = document.querySelector('[data-pdp-options]');
    if (!options || options.getAttribute('data-preselect-subscription') !== 'true') return;
    if (document.querySelector('[data-pdp-sub]')) return; // the Subscribe & Save panel picks the plan itself
    if (/[?&]selling_plan=/.test(window.location.search)) return;

    var fieldset = document.querySelector('[data-subscription-selectors]');
    if (!fieldset || fieldset.querySelector('input[name="selling_plan"]:checked')) return;

    var groupRadio = fieldset.querySelector('[data-subscription-group] input[data-toggles-group]');
    if (!groupRadio) return;

    groupRadio.checked = true;
    groupRadio.dispatchEvent(new Event('change', { bubbles: true }));

    // If the theme script has not loaded yet, do what its change handler does
    var plans = fieldset.querySelector('[data-group-toggle="' + groupRadio.value + '"]');
    if (plans) {
      plans.classList.remove('hide');
      var firstPlan = plans.querySelector('input[name="selling_plan"]');
      if (firstPlan && !firstPlan.checked) {
        firstPlan.checked = true;
        firstPlan.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', preselectSubscription);
  } else {
    preselectSubscription();
  }
})();


/*
  4. "Subscribe & Save" buy panel (snippets/pdp-subscribe.liquid)
     Weight → delivery (jars × days) → today's total. Drives the theme's own,
     now hidden, product form: quantity = jars, selling_plan = the Appstle plan
     whose interval matches the days.
*/
(function () {
  'use strict';

  var UNIT_DAYS = { day: 1, days: 1, week: 7, weeks: 7, wk: 7, month: 30, months: 30, mo: 30 };

  /* Delivery interval in days, read from the plan's name, options and description.
     Handles "30 days", "30 Day(s)", "6 weeks", "1.5 months", "3-month", "every month",
     "monthly", "quarterly"… Returns 0 when no interval can be read. */
  function planDays(plan) {
    var text = [plan.name, plan.description].concat(plan.options || []).join(' ').toLowerCase();
    var m = text.match(/(\d+(?:[.,]\d+)?)\s*-?\s*(days?|weeks?|wks?|months?|mos?)\b/);
    if (m) {
      var unit = m[2].replace(/s$/, '');
      return Math.round(parseFloat(m[1].replace(',', '.')) * (UNIT_DAYS[unit] || UNIT_DAYS[unit + 's'] || 0));
    }
    m = text.match(/every\s+(other\s+)?(day|week|month)\b/);
    if (m) return UNIT_DAYS[m[2]] * (m[1] ? 2 : 1);
    if (/\bbi-?weekly\b|\bfortnight/.test(text)) return 14;
    if (/\bweekly\b/.test(text)) return 7;
    if (/\bbi-?monthly\b/.test(text)) return 60;
    if (/\bquarter(ly)?\b/.test(text)) return 90;
    if (/\bmonthly\b/.test(text)) return 30;
    return 0;
  }

  /* The plan for a delivery of `days`: an exact match first, otherwise the closest
     interval within ~10% (so "4 weeks" fits 30 days and "6 weeks" fits 45). */
  function findPlan(plans, days) {
    var best = null;
    var bestDiff = Math.max(3, Math.round(days * 0.1)) + 0.5;
    plans.forEach(function (p) {
      var d = planDays(p);
      if (!d) return;
      var diff = Math.abs(d - days);
      if (diff < bestDiff) { best = p; bestDiff = diff; }
    });
    return best;
  }

  /* Percent off for an adjustment (percentage, fixed amount or fixed price) */
  function percentOff(adj, price) {
    if (!adj || !price) return null;
    if (adj.type === 'percentage') return adj.value;
    if (adj.type === 'fixed_amount') return (adj.value / price) * 100;
    if (adj.type === 'price') return (1 - adj.value / price) * 100;
    return null;
  }

  function formatMoney(cents, format) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (format || '${{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, function (_, type) {
      switch (type) {
        case 'amount_no_decimals': return withCommas.split('.')[0];
        case 'amount_with_comma_separator': return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
        case 'amount_no_decimals_with_comma_separator': return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        default: return withCommas + '.' + parts[1];
      }
    });
  }

  function niceDays(n) {
    var whole = Math.floor(n);
    var rest = n - whole;
    if (rest === 0) return String(whole);
    if (Math.abs(rest - 0.5) < 0.01) return whole + '½';
    return n.toFixed(1);
  }

  function fire(el) {
    el.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function init(root) {
    if (root.dataset.pdpSubReady) return;
    root.dataset.pdpSubReady = 'true';

    var data;
    try {
      data = JSON.parse(root.querySelector('[data-pdp-sub-data]').textContent);
    } catch (e) {
      if (window.console) console.error('[Subscribe & Save] Could not read the panel data', e);
      return;
    }
    var plans = (data.plans || []).filter(Boolean);
    var price = data.price || 0;
    var money = function (c) { return formatMoney(c, data.moneyFormat); };

    var formId = root.dataset.formId;
    var form = document.getElementById(formId);
    var section = root.closest('.shopify-section') || root.parentNode;
    section.classList.add('pdp-sub-active');
    if (data.hidePrice) section.classList.add('pdp-sub-hide-price');

    var weights = Array.prototype.slice.call(root.querySelectorAll('.pdp-sub__weight input'));
    var cards = Array.prototype.slice.call(root.querySelectorAll('.pdp-sub__plan'));
    var modeInputs = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-sub-mode]'));
    var subCard = root.querySelector('[data-pdp-sub-card]');
    var hint = root.querySelector('[data-pdp-sub-hint]');
    var cta = root.querySelector('[data-pdp-sub-cta]');
    var error = root.querySelector('[data-pdp-sub-error]');
    var foot = root.querySelector('[data-pdp-sub-foot]');
    var renew = root.querySelector('[data-renew]');
    var hintTemplate = root.dataset.hint || '';

    /* Each delivery card: its Appstle plan and prices */
    cards.forEach(function (card) {
      var days = parseInt(card.dataset.days, 10);
      var jars = parseInt(card.dataset.jars, 10);
      var plan = findPlan(plans, days);
      var adjs = plan ? (plan.adjustments || []).filter(Boolean).sort(function (a, b) { return a.position - b.position; }) : [];
      /* First order: the plan's discount. Refills: the plan's second discount if it
         has one, otherwise the block's "Later orders %" (Appstle rewards such as
         20% from order 2 are applied at renewal and are not in the plan data). */
      var first = plan ? percentOff(adjs[0], price) : null;
      var later = plan && adjs[1] ? percentOff(adjs[1], price) : null;
      if (first === null) first = data.firstOff || 0;
      if (later === null) later = data.recurringOff || 0;
      var unitFirst = Math.round(price * (100 - first) / 100);
      var unitLater = Math.round(price * (100 - later) / 100);
      card._pdp = {
        plan: plan, days: days, jars: jars,
        full: price * jars, first: unitFirst * jars, later: unitLater * jars
      };
      card.querySelector('[data-per-day]').textContent = money(Math.round(unitFirst * jars / days));
      card.querySelector('[data-compare]').textContent = money(price * jars);
      card.querySelector('[data-first]').textContent = money(unitFirst * jars);
      var missing = card.querySelector('[data-plan-missing]');
      if (!plan && missing) missing.hidden = !data.designMode;
      if (!plan && !data.designMode) card.dataset.unavailable = 'true';
    });

    /* Some deliveries have no plan: say which plans the product has, so the names
       can be fixed in Appstle (console always, a note in the theme editor) */
    var unmatched = cards.filter(function (c) { return !c._pdp.plan; });
    if (unmatched.length) {
      var needed = unmatched.map(function (c) { return c._pdp.days; })
        .filter(function (d, i, a) { return a.indexOf(d) === i; });
      var found = plans.map(function (p) {
        var d = planDays(p);
        return '"' + p.name + '"' + (d ? ' (' + d + ' days)' : ' (no interval found)');
      });
      var msg = 'No subscription plan found for every ' + needed.join(', ') + ' days. ' +
        (plans.length
          ? 'Plans on this product: ' + found.join(', ') + '. Put the interval in each Appstle frequency name, e.g. "Every 30 days".'
          : 'This product has no subscription plans. Add it to the Appstle plan.');
      if (window.console) console.warn('[Subscribe & Save] ' + msg);
      if (data.designMode) {
        var note = document.createElement('p');
        note.className = 'pdp-sub__editor-note';
        note.textContent = msg + ' (Only shown in the theme editor.)';
        root.insertBefore(note, root.firstChild.nextSibling);
      }
    }

    function currentWeight() {
      return weights.find(function (w) { return w.checked; }) || weights[0];
    }
    function weightCards() {
      var w = currentWeight();
      return cards.filter(function (c) { return w && c.dataset.weight === w.value && !c.dataset.unavailable; });
    }
    function currentCard() {
      return weightCards().find(function (c) { return c.querySelector('input').checked; }) || null;
    }
    function mode() {
      var m = modeInputs.find(function (i) { return i.checked; });
      return m ? m.value : 'subscribe';
    }

    /* Set the theme's hidden form to match the panel */
    function syncForm(card, isSub) {
      if (!form) return;
      var qty = document.querySelector('[name="quantity"][form="' + formId + '"]') || form.querySelector('[name="quantity"]');
      if (!qty) {
        qty = document.createElement('input');
        qty.type = 'hidden'; qty.name = 'quantity'; qty.setAttribute('form', formId);
        root.appendChild(qty);
      }
      qty.value = isSub && card ? card._pdp.jars : 1;

      var plan = isSub && card ? card._pdp.plan : null;
      var groupRadios = document.querySelectorAll('input[name="selling-plan-group"][form="' + formId + '"]');
      var planRadios = document.querySelectorAll('input[name="selling_plan"][form="' + formId + '"]');
      if (groupRadios.length || planRadios.length) {
        groupRadios.forEach(function (g) {
          var on = plan ? g.value === String(plan.group) : g.value === '';
          if (on && !g.checked) { g.checked = true; fire(g); }
        });
        planRadios.forEach(function (r) {
          var on = !!plan && r.value === String(plan.id);
          if (r.checked !== on) { r.checked = on; if (on) fire(r); }
        });
        if (plan) {
          var wrap = document.querySelector('[data-group-toggle="' + plan.group + '"]');
          if (wrap) wrap.classList.remove('hide');
        }
      } else {
        /* No theme subscription picker on the page: keep our own field */
        var own = root.querySelector('input[name="selling_plan"]');
        if (!own) {
          own = document.createElement('input');
          own.type = 'hidden'; own.name = 'selling_plan'; own.setAttribute('form', formId);
          root.appendChild(own);
        }
        own.value = plan ? plan.id : '';
        own.disabled = !plan;
      }
    }

    var forcedOnce = false;

    function render() {
      var w = currentWeight();
      var chews = w ? parseInt(w.dataset.chews, 10) : 1;
      var visible = weightCards();

      cards.forEach(function (c) { c.hidden = visible.indexOf(c) === -1; });
      if (visible.length && !currentCard()) visible[0].querySelector('input').checked = true;

      /* No delivery for this weight: one-time purchase only */
      var canSub = visible.length > 0;
      subCard.hidden = !canSub;
      if (!canSub && mode() === 'subscribe') {
        forcedOnce = true;
        modeInputs.forEach(function (i) { i.checked = i.value === 'once'; });
      } else if (canSub && forcedOnce) {
        /* Back on a weight with deliveries: return to Subscribe & Save */
        forcedOnce = false;
        modeInputs.forEach(function (i) { i.checked = i.value === 'subscribe'; });
      }

      var isSub = mode() === 'subscribe' && canSub;
      var card = isSub ? currentCard() : null;
      subCard.classList.toggle('is-active', isSub);
      cards.forEach(function (c) { c.classList.toggle('is-selected', c === card); });
      root.classList.toggle('is-once', !isSub);

      if (hint) {
        hint.textContent = hintTemplate
          .replace('[chews]', chews + (chews === 1 ? ' chew' : ' chews'))
          .replace('[days]', niceDays((data.jarSize || 90) / chews));
      }

      var total = isSub && card ? card._pdp.first : price;
      var compare = isSub && card ? card._pdp.full : 0;
      root.querySelector('[data-total]').textContent = money(total);
      root.querySelector('[data-total-compare]').textContent = compare > total ? money(compare) : '';

      if (renew) {
        renew.hidden = !(isSub && card);
        if (isSub && card) {
          renew.textContent = (renew.dataset.template || '')
            .replace('[price]', money(card._pdp.later))
            .replace('[days]', card._pdp.days)
            .replace('[jars]', card._pdp.jars);
        }
      }
      if (foot) foot.hidden = !isSub;

      if (cta && data.available) {
        cta.textContent = (isSub ? cta.dataset.subTemplate : cta.dataset.onceTemplate).replace('[price]', money(total));
      }
      syncForm(card, isSub);
    }

    root.addEventListener('change', function (e) {
      if (e.target.hasAttribute && e.target.hasAttribute('data-pdp-sub-mode')) forcedOnce = false;
      if (e.target.name && e.target.name.indexOf('pdp-sub-plan') === 0) {
        modeInputs.forEach(function (i) { i.checked = i.value === 'subscribe'; });
      }
      if (error) error.hidden = true;
      render();
    });

    /* Tapping the subscribe card body picks subscribe too */
    subCard.addEventListener('click', function (e) {
      if (e.target.closest('input, label')) return;
      if (mode() !== 'subscribe') {
        modeInputs.forEach(function (i) { i.checked = i.value === 'subscribe'; });
        render();
      }
    });

    if (cta) {
      cta.addEventListener('click', function () {
        render();
        var button = form && (form.querySelector('[data-add-to-cart]') || form.querySelector('[type="submit"]'));
        if (!button || button.disabled) {
          if (error) { error.textContent = cta.dataset.soldOut || 'Unavailable'; error.hidden = false; }
          return;
        }
        cta.classList.add('is-loading');
        cta.disabled = true;
        button.click();
        setTimeout(function () { cta.classList.remove('is-loading'); cta.disabled = !data.available; }, 1200);
      });
    }

    render();
    /* The theme may reset its picker once its own script loads */
    window.addEventListener('load', render);
  }

  function initAll() { document.querySelectorAll('[data-pdp-sub]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();